export default __webpack_public_path__ + "static/media/head-front.7b1e3888.png";